module.exports = "/images/company.png?73cad06330bbcb112514e24a4e6589cf";